import React from 'react';
import {getRequest} from "@requests";
import {connect} from "react-redux";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import {compose} from "redux";
import {withStyles} from "@material-ui/core";
import {styles} from "../../../styles/documents";
import {withTranslation} from "react-i18next";

class SingleSelectRemote extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        const {defaultValue} = this.props;
        this.state = {
            value: defaultValue ? Number(defaultValue) : 0,
            optionsSelectRemote: [],
        };
        this.initialization = this.initialization.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.initialization();
        this._isMounted = true;
    }
    async initialization() {
        const {apiDomainVikon, scheme} = this.props;
        const optionsSingleSelectRemote = await getRequest(`${apiDomainVikon}${scheme.type.url}`);
        if (!optionsSingleSelectRemote.errors) {
            if (this._isMounted) {
                this.setState({optionsSelectRemote: optionsSingleSelectRemote});
            }
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    handleChange = (e) => {
        const {state} = this;
        let value = e.target.value;
        this.setState({...state, value: Number(value)});
    };
    render() {
        const {classes, name, scheme, refs, isLabel, t, i18n} = this.props;
        const {handleChange, state} = this;
        return (
            <React.Fragment>
                <input
                    type="hidden"
                    ref={input => refs[name] = input}
                    value={state.value} />
                {state.optionsSelectRemote.length > 0
                    ? <FormControl size="small" variant="outlined" fullWidth>
                        {isLabel !== false
                            ? <InputLabel id={name} required={scheme.required === true}>{scheme.label}</InputLabel>
                            : null}
                        <Select
                            labelId={name}
                            value={state.value}
                            onChange={handleChange}
                        >
                            <MenuItem value={0}>{t('not_selected')}</MenuItem>
                            {state.optionsSelectRemote.map(value => {
                                return (
                                    <MenuItem key={value.id} value={typeof value.id === 'number' ? Number(value.id) : value.id}>
                                        {i18n.language === 'en' && value.value_en ? value.value_en : value.value}
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                    : null}
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        apiDomainVikon: state.apiDomainVikon,
    };
}

export default compose(withStyles(styles), connect(mapStateToProps))(withTranslation()(SingleSelectRemote));